import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { saveEegSegment } from "../../actions/patientActions";

const SaveSegmentModal = ({
  show,
  handleClose,
  token,
  segmentData,
  onSaved,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedLabel1, setSelectedLabel1] = useState("seizure");
  const [selectedLabel2, setSelectedLabel2] = useState("seizure");
  const dispatch = useDispatch();

  const labels = ["seizure", "stroke", "artifact"];

  const handleConfirm = async () => {
    if (!segmentData) {
      toast.error("No segment data to save");
      return;
    }

    setLoading(true);
    try {
      await dispatch(
        saveEegSegment(token, {
          ...segmentData,
          ch1_label: selectedLabel1,
          ch2_label: selectedLabel2,
        })
      );
      setSelectedLabel1("seizure");
      setSelectedLabel2("seizure");
      onSaved && onSaved();
      handleClose();
    } catch (error) {
      // Error toast is handled in the action
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title id="contained-modal-title-vcenter">
          Tag EEG Segment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>Time Range:</strong>{" "}
            {segmentData?.segment_start_time?.toFixed(2)}s -{" "}
            {segmentData?.segment_end_time?.toFixed(2)}s
          </p>
          <p>
            <strong>Duration:</strong>{" "}
            {(
              (segmentData?.segment_end_time || 0) -
              (segmentData?.segment_start_time || 0)
            ).toFixed(2)}
            s
          </p>
        </div>
        <div>
          <label style={{ marginBottom: "10px", display: "block" }}>
            <strong>Select Label for Channel 1:</strong>
          </label>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {labels.map((label) => (
              <label
                key={label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: "4px",
                  backgroundColor:
                    selectedLabel1 === label ? "#e3f2fd" : "transparent",
                }}
              >
                <input
                  type="radio"
                  name="segmentLabel1"
                  value={label}
                  checked={selectedLabel1 === label}
                  onChange={(e) => setSelectedLabel1(e.target.value)}
                  style={{ marginRight: "10px" }}
                />
                <span style={{ textTransform: "capitalize" }}>{label}</span>
              </label>
            ))}
          </div>
        </div>
        <div>
          <label style={{ marginBottom: "10px", display: "block" }}>
            <strong>Select Label for Channel 2:</strong>
          </label>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {labels.map((label) => (
              <label
                key={label}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: "4px",
                  backgroundColor:
                    selectedLabel2 === label ? "#e3f2fd" : "transparent",
                }}
              >
                <input
                  type="radio"
                  name="segmentLabel2"
                  value={label}
                  checked={selectedLabel2 === label}
                  onChange={(e) => setSelectedLabel2(e.target.value)}
                  style={{ marginRight: "10px" }}
                />
                <span style={{ textTransform: "capitalize" }}>{label}</span>
              </label>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleConfirm} disabled={loading}>
          {loading ? "Saving..." : "Save Segment"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveSegmentModal;
